"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  renderWebChat: true,
  createCognitiveServicesBingSpeechPonyfillFactory: true,
  createCognitiveServicesSpeechServicesPonyfillFactory: true,
  renderMarkdown: true
};
Object.defineProperty(exports, "createCognitiveServicesBingSpeechPonyfillFactory", {
  enumerable: true,
  get: function get() {
    return _createCognitiveServicesBingSpeechPonyfillFactory.default;
  }
});
Object.defineProperty(exports, "createCognitiveServicesSpeechServicesPonyfillFactory", {
  enumerable: true,
  get: function get() {
    return _createCognitiveServicesSpeechServicesPonyfillFactory.default;
  }
});
Object.defineProperty(exports, "renderMarkdown", {
  enumerable: true,
  get: function get() {
    return _renderMarkdown.default;
  }
});
exports.renderWebChat = exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _indexMinimal = require("./index-minimal");

Object.keys(_indexMinimal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _indexMinimal[key];
    }
  });
});

var _addVersion = _interopRequireDefault(require("./addVersion"));

var _renderWebChat = _interopRequireDefault(require("./renderWebChat"));

var _createCognitiveServicesBingSpeechPonyfillFactory = _interopRequireDefault(require("./createCognitiveServicesBingSpeechPonyfillFactory"));

var _createCognitiveServicesSpeechServicesPonyfillFactory = _interopRequireDefault(require("./createCognitiveServicesSpeechServicesPonyfillFactory"));

var _FullReactWebChat = _interopRequireDefault(require("./FullReactWebChat"));

var _renderMarkdown = _interopRequireDefault(require("./renderMarkdown"));

var renderWebChat = _renderWebChat.default.bind(null, _FullReactWebChat.default);

exports.renderWebChat = renderWebChat;
var _default = _FullReactWebChat.default;
exports.default = _default;
window['WebChat'] = (0, _objectSpread2.default)({}, window['WebChat'], {
  createCognitiveServicesBingSpeechPonyfillFactory: _createCognitiveServicesBingSpeechPonyfillFactory.default,
  createCognitiveServicesSpeechServicesPonyfillFactory: _createCognitiveServicesSpeechServicesPonyfillFactory.default,
  ReactWebChat: _FullReactWebChat.default,
  renderMarkdown: _renderMarkdown.default,
  renderWebChat: renderWebChat
});
(0, _addVersion.default)('full');